export function parseIsoDateLocal(value) {
  const raw = String(value || "").trim();
  const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);
  const dt = new Date(y, mo, d, 12, 0, 0, 0);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function formatIsoDateLocal(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function addMonthsSafe(date, months) {
  const d = new Date(date.getTime());
  const day = d.getDate();
  d.setDate(1);
  d.setMonth(d.getMonth() + Number(months || 0));
  const lastDay = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  d.setDate(Math.min(day, lastDay));
  return d;
}

export function periodicitaToMonths(periodicita) {
  const p = String(periodicita || "").trim();
  if (p === "mesicne") return 1;
  if (p === "ctvrtletne") return 3;
  if (p === "pulrocne") return 6;
  if (p === "rocne") return 12;
  return 0;
}

export function generateVisitDates({ datumOd, datumDo, periodicita }) {
  const from = parseIsoDateLocal(datumOd);
  const to = parseIsoDateLocal(datumDo);
  const step = periodicitaToMonths(periodicita);

  if (!from || !to || !step) return [];
  if (from.getTime() > to.getTime()) return [];

  const out = [];
  let cur = new Date(from.getTime());

  out.push(formatIsoDateLocal(cur));
  cur = addMonthsSafe(cur, step);

  while (cur.getTime() < to.getTime()) {
    out.push(formatIsoDateLocal(cur));
    cur = addMonthsSafe(cur, step);
  }

  return out;
}
